import PropTypes from 'prop-types';

// Internal =====================================
const { Component } = React;

// Dropdown Component ===========================
export default class Dropdown extends Component {
  static propTypes = {
    wrapperClassName: PropTypes.string,
    textClassName: PropTypes.string,
    inputName: PropTypes.string,
    isRequired: PropTypes.bool,
    options: PropTypes.array,
    defaultOption: PropTypes.string,
    changeHandler: PropTypes.func,
    showDefault: PropTypes.bool,
    disabled: PropTypes.bool,
    validations: PropTypes.array
  };

  static defaultProps = {
    wrapperClassName: '',
    textClassName: 'form-control',
    inputName: '',
    isRequired: false,
    showDefault: true,
    options: [],
    defaultOption: '--',
    disabled: false,
    validations: []
  };

  constructor(props) {
    super(props);

    let txt = props.defaultOption ? props.defaultOption : props.options[0].name;
    let tmpOpt;

    if (props.defaultValue) {
      tmpOpt = props.options.find(opt => `${ opt.val}` === props.defaultValue);
      txt = (tmpOpt) ? tmpOpt.name : txt;
    }

    this.state = {
      txt,
      val: (props.defaultValue) ? props.defaultValue : '',
      visibility: 'show'
    };
  }

  preventIOSFocus = (e) => {
    e.preventDefault();
  }

  changeHandler = (e) => {
    const txt = e.target.options[e.target.selectedIndex].text;
    const val = e.target.options[e.target.selectedIndex].value;

    this.setState({ txt, val });
    if (typeof this.props.changeHandler === 'function') {
      this.props.changeHandler(e);
    }
  }

  hide = () => this.setState({ visibility: 'hide' });

  render() {
    const { props, changeHandler, preventIOSFocus } = this;
    const { id, wrapperClassName, inputName, isRequired, options, defaultOption, size, disabled } = props;
    const { val } = this.state;
    const opts = [];

    // if (this.props.showDefault) {
    //     opts.push( <option key={`${inputName}-default`} value="" selected>{ defaultOption }</option> );
    // }

    options.forEach((option, index) => opts.push(<option key={ `${inputName}-${index}` } value={ option.val }>{ option.name }</option>));

    return (
      <div className={`${this.state.visibility} ${size}`}>
        <div id={ id } className={ wrapperClassName + ' custom-ddl pr' }>
          <select
            name={ inputName }
            required={ isRequired }
            onChange={ changeHandler }
            onFocus={ preventIOSFocus }
            onBlur={ preventIOSFocus }
            value={ val }
            disabled={ disabled }
            // defaultValue=''
            // validations={ validations }
          >
            <option key={`${inputName}-default`} value="">{ defaultOption }</option>
            { opts }
          </select>
        </div>
      </div>
    );
  }
}
